import styled from "styled-components";

export const Wrapper = styled.div`
  position: absolute;
  left: 24px;
  bottom: 24px;
  cursor: default;
`;

export const Container = styled.div`
  background-color: var(--black-300);
  border-radius: 4px;
  padding: 20px;
  z-index: 999;
  width: 330px;
`;

export const Header = styled.div`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.span`
  font-size: 1rem;
  font-family: DM Sans;
  font-weight: 500;
  color: var(--primary);
  padding: 0;
  max-width: 250px;
  white-space: nowrap;
  overflow: hidden;
  padding-right: 1.2rem;
  text-overflow: ellipsis;
`;

export const CloseButton = styled.button`
  background-color: var(--black-400);
  padding: 0rem;
  width: 30px;
  height: 30px;
  border-radius: 100%;
  margin-left: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.4s;

  &:hover {
    background-color: var(--black-100);
  }

  img {
    width: 20px;
    height: 20px;
  }
`;

export const Body = styled.div`
  input {
    width: 100%;
  }

  label {
    margin-top: 1rem;
  }
`;

export const WorkingStatus = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem;
  background-color: var(--black-200);
  border-radius: 0.3rem;
  margin-top: 1rem;
  cursor: pointer;

  img {
    width: 1.7rem;
    height: 1.7rem;
    padding: 0.3rem;
    background: var(--black-100);
    border-radius: 4px;
  }

  &.skeleton {
    padding: 0;
    background: transparent;
  }

  &.available {
    color: var(--primary);
    background: var(--darker-primary);
    justify-content: center;
    margin-top: 1rem;
  }
`;
